import api from './api';

/** Find a realtor / Find a conveyancer — members, plus a name search of the official register. */
const directoryService = {
  realtors: (params) => api.get('/public/realtors', { params }).then((r) => r.data),
  conveyancers: (params) => api.get('/public/conveyancers', { params }).then((r) => r.data),
};

export default directoryService;
